import React, { useEffect, useState } from 'react'
import { ColorRing } from 'react-loader-spinner';
import { useNavigate } from 'react-router-dom';
import Header from '../../header/Header';
import Banner from '../../banner/Banner';
import { WeeklyParsha } from '../../../service/service';
import Footer from '../../footer/Footer';
import DataItem from '../../../ReuseableComponents/DataItem';


function ParshaOfTheWeek() {

    const navigate = useNavigate();
    const [portions, setPortions] = useState([]);
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        // Scroll to the top when the component mounts
        window.scrollTo(0, 0);
    
        // Optionally, you can also add a listener for navigation changes
        const handleScrollToTop = () => {
          window.scrollTo(0, 0);
        };
    
        // Attach the listener to the "beforeunload" event
        window.addEventListener('beforeunload', handleScrollToTop);
    
        // Clean up the listener when the component unmounts
        return () => {
          window.removeEventListener('beforeunload', handleScrollToTop);
        };
      }, []);
    useEffect(() => {
        setLoading(true)
        WeeklyParsha().then((result) => {
            setLoading(false)
           if(result.status){
            // Prefer the new `parshas` array (all portions for the week, in leining order).
            // Fall back to the single `data` object for older API responses during rollout.
            const list = result.parshas ?? (result.data ? [result.data] : []);
            setPortions(list)
           }
        })
        .catch((error)=>{
            console.log(error)
        })
    }, [])



    const OpenCategory = (obj) => {

        const data = obj;
        navigate(`/${data?.slug}`);

    }
    // First portion drives the banner description; on a double week the heading
    // combines every portion, e.g. "Parshas Matos-Masei".
    const firstPortion = portions[0];
    const stripParshas = (name) => (name ?? "").replace(/^Parshas\s+/i, "");
    const bannerTitle =
        portions.length > 1
            ? "Parshas " + portions.map((p) => stripParshas(p.title ?? p.name)).join("-")
            : firstPortion?.title ?? firstPortion?.name;

    return (

        <>
            <Header />
            <Banner title={bannerTitle} description={firstPortion?.description === firstPortion?.title || firstPortion?.description === firstPortion?.name ? "" : firstPortion?.description} />
            {
                loading ?
                    <div className='flex justify-center min-h-[40vh]'>
                        <ColorRing
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="blocks-loading"
                            wrapperStyle={{}}
                            wrapperClass="blocks-wrapper"
                            colors={['#D2D6DC', '#D2D6DC', '#D2D6DC', '#D2D6DC', '#D2D6DC']}
                        />
                    </div>
                    :
                    <>
                        {
                            portions.length > 0 ?
                                <section className='px-2 xs:px-5 pt-6 pb-[38px] md:pt-8 md:pb-[100px]'>
                                    <div className='2xl:max-w-2xl xl:max-w-xl lg:max-w-lg md:max-w-md sm:max-w-sm mx-auto text-primaryDark'>

                                        <section className='px-2 xs:px-5 pt-6 pb-[38px] md:pt-8 md:pb-[100px]'>
                                                <div className='2xl:max-w-2xl xl:max-w-xl lg:max-w-lg md:max-w-md sm:max-w-sm mx-auto text-primaryDark'>
                                                    <div className='py-4 sm:py-8 space-y-3 sm:space-y-4'>
                                                        {portions.map((portion) => (
                                                            <DataItem
                                                                weeklyParsha={true}
                                                                category={true}
                                                                key={portion.id}
                                                                dataObj={portion}
                                                            />
                                                        ))}
                                                    </div>
                                                </div>
                                            </section>

                                    </div>
                                </section>
                                :
                                <div className='text-primaryDark text-lg font-bold text-center pt-10 h-[50vh]'>
                                    No Data Found
                                </div>
                        }
                    </>
            }
 <Footer />
        </>
    )
}

export default ParshaOfTheWeek